export default __webpack_public_path__ + "static/media/category.af47545f.png";